// Опции месяцев
export const monthOptions = [
    {value: 1, label: 'Январь'},
    {value: 2, label: 'Февраль'},
    {value: 3, label: 'Март'},
    {value: 4, label: 'Апрель'},
    {value: 5, label: 'Май'},
    {value: 6, label: 'Июнь'},
    {value: 7, label: 'Июль'},
    {value: 8, label: 'Август'},
    {value: 9, label: 'Сентябрь'},
    {value: 10, label: 'Октябрь'},
    {value: 11, label: 'Ноябрь'},
    {value: 12, label: 'Декабрь'},
];


export const statusOptions = [
    {value: 'active', label: 'Активна', color: 'green'},
    {value: 'inactive', label: 'Неактивна', color: 'red'}
];

export const daysOfWeek = [
    { value: 1, label: 'Понедельник' },
    { value: 2, label: 'Вторник' },
    { value: 3, label: 'Среда' },
    { value: 4, label: 'Четверг' },
    { value: 5, label: 'Пятница' },
    { value: 6, label: 'Суббота' },
    { value: 7, label: 'Воскресенье' }
];

export const weekNumbers = [
    { value: 1, label: 'Первая' },
    { value: 2, label: 'Вторая' },
    { value: 3, label: 'Третья' },
    { value: 4, label: 'Четвертая' },
    { value: 5, label: 'Последняя' }
];

export const frequencyOptions = [
    { value: 'monthly', label: 'Ежемесячно' },
    { value: 'quarterly', label: 'Ежеквартально' },
    { value: 'yearly', label: 'Ежегодно' },
    { value: 'custom', label: 'Произвольный' }
];